import { BusinessValidation, BusinessValidationType } from '../models/policy-business.model';
import { BusinessHonoraryNote, HonoraryNoteLine } from '../models/honorarynote-business.model';

export function calculateVat(unitPrice: string, number: string, vatPercentage: string): number {
  let result = +unitPrice * +number * +vatPercentage / 100;
  if (isNaN(result)) {
    result = 0;
  }

  return result;
}

export function calculateAmount(unitPrice: string, number: string): number {
  let result = +unitPrice * +number;
  if (isNaN(result)) {
    result = 0;
  }

  return result;
}

export function calculateSubtotal(unitPrice: string, number: string, vatPercentage: string): number {
  let result = +unitPrice * +number * (100 + +vatPercentage) / 100;
  if (isNaN(result)) {
    result = 0;
  }

  return result;
}

export function getTotal(honoraryNoteLines: HonoraryNoteLine[]) {
  let result = 0;
  honoraryNoteLines.forEach(x => {
    result = result + calculateSubtotal(x.unitPrice, x.number, x.vatPercentage);
  });

  return result;
}

export function validateHonoraryNote(honoraryNote: BusinessHonoraryNote): BusinessValidation[] {
  const result: BusinessValidation[] = [];

  if (honoraryNote.structuredMessage !== null && honoraryNote.structuredMessage !== undefined) {
    // structured message validation
    const validationInProgress = { businessValidationType: BusinessValidationType.hnStructuredMessage, errorMessage: '', hasError: false} as BusinessValidation;
    result.push(validationInProgress);
    
    if (honoraryNote.structuredMessage.length < 14) {
      const businessError = { businessValidationType: BusinessValidationType.hnStructuredMessage, errorMessage: '', hasError: true} as BusinessValidation;
      result.push(businessError);
    } else {
      if (!mod9710(honoraryNote.structuredMessage.replace(/[/]/g, ''))) {
        const businessError = { businessValidationType: BusinessValidationType.hnStructuredMessage, errorMessage: '', hasError: true} as BusinessValidation;
        result.push(businessError);
      }
    }
  }

  return result;
}


export function mod9710(validationString: string): boolean {
  if (validationString.length < 2) { return false; }
  const part = validationString.slice(0, validationString.length - 2);
  const reminder = validationString.slice(validationString.length - 2, validationString.length);

  return (parseInt(part, 10) % 97) === parseInt(reminder, 10);
}
